import StyledPaper  from "./StyledPaper";  

export default StyledPaper;
